<template>
  <div>
    <div class="tool">
        <div id="mt16" v-if="determine != 'check'">
            <a href="http://exediting.com/" target="_blank">
                <img src="../assets/log-introduce.jpg" alt="" style="width: 72px;height: 36.8px;">
            </a>

            <p class="title">介绍</p>
        </div>

        <div class="buttons" v-if="determine != 'check'">
            <!-- <router-link to="/paper/my_polish"><el-button size="middle">我的润色</el-button></router-link>
            <router-link to="/paper/my_check"><el-button size="middle">我的查重</el-button></router-link> -->
            <div style="text-indent:2em;" v-if="determine == 'polish'">
                <p >
                ExEditing拥有一支覆盖生物医药领域的资深母语编辑及审稿人团队，团队成员以英语为母语，具有硕士或博士学位。根据您的研究内容，我们为您匹配最合适的学术编辑，母语专家或审稿人，为您提供专业的语言润色、学术翻译、降重改写和同行评审。此外，我们还提供科研绘图、格式修改、期刊推荐等支持服务，助力SCI学术发表。
                </p>
                <p>
                    ExEditing严格执行保密制度，充分保护稿件信息和客户隐私，杜绝信息外泄。
                </p>
<!--                <span style="font-weight: bold;">备注:</span>-->
<!--                <p>(1) 由方向匹配的专家提供免费的同行评审</p>-->
<!--                <p>(2) 根据目标杂志，赠送格式修改服务</p>-->
<!--                <p>(3) 为您免费推荐3-5合适的期刊</p>-->
            </div>
            <div style="text-indent:2em;" v-if="determine == 'dropWeight'">
                <p >
                ExEditing拥有一支覆盖生物医药领域的资深母语编辑及审稿人团队，团队成员具有硕士或博士学位，熟悉细胞生物学、分子生物学、前瞻性研究、回顾性分析等多个领域。根据您的研究内容，我们为您匹配最合适的学术编辑、提供专业的降重改写和语言润色。此外，我们还提供科研绘图、格式修改、期刊推荐等支持服务，助力SCI学术发表。
                </p>
                <p>ExEditing严格执行保密制度，充分保护稿件信息和客户隐私，杜绝信息外泄。</p>
<!--                <span style="font-weight: bold;">备注:</span>-->
<!--                <p>(1) 由方向匹配的专家提供免费的同行评审</p>-->
<!--                <p>(2) 根据目标杂志，赠送格式修改服务</p>-->
<!--                <p>(3) 为您免费推荐3-5合适的期刊</p>-->
            </div>

            <a href="http://exediting.com/" target="_blank" style="width: 35px;">更多</a>
        </div>
        <div id="mt17">
            <div class="title">价格</div>
            <div @click="dialogTableVisible = true" class="check">查看</div>
            <!-- <el-button type="text" @click="dialogTableVisible = true">查看</el-button> -->
        </div>
        <el-dialog title="价格" :visible.sync="dialogTableVisible">
            <el-table :data="polishData" style="width: 82.1%" v-if="determine == 'polish'">
                <el-table-column label="润色">
                    <el-table-column
                    prop="numberOfWords"
                    label="单词数（个）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="cycle"
                    label="周期（天）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="expense"
                    label="费用（元）"
                    width="300">
                    </el-table-column>
                </el-table-column>
            </el-table>
            <el-table :data="ChineseEnglishTranslation" style="width: 82.1%" v-if="determine == 'polish'">
                <el-table-column label="中译英">
                    <el-table-column
                    prop="numberOfWords"
                    label="文字数（个）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="cycle"
                    label="周期（天）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="expense"
                    label="费用（元）"
                    width="300">
                    </el-table-column>
                </el-table-column>
            </el-table>
            <el-table :data="DropWeight" style="width: 89.5%" v-if="determine == 'dropWeight'">
                <el-table-column label="降重">
                    <el-table-column
                    prop="numberOfWords"
                    label="单词数（个）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="RepetitionRate"
                    label="重复率（%）"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="cycle"
                    label="周期（天）"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="expense"
                    label="费用（元）"
                    width="200">
                    </el-table-column>
                </el-table-column>
            </el-table>
            <el-table :data="DuplicateChecking" style="width: 48.6%" v-if="determine == 'check'">
                <el-table-column label="查重">
                    <el-table-column
                    prop="category"
                    label="类别"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="expense"
                    label="费用（元）"
                    width="200">
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
    <div class="tool mt15"  v-if="type==1">
      <h3>使用说明</h3>
        <div>
            <el-collapse class="paper-check-instruction" v-model="activeName" accordion>
                <el-collapse-item title="Turnitin 国际版" name="1">
                    Turnitin论文相似性检测系统适用于中国（包括香港、澳门、台湾）、美国、澳洲、新西兰、新加坡、马来西来、日本、韩国、俄罗斯等全球140多个国家。可检测简繁体中文 、英文、俄文、韩语、日语、法语等语言；可用于检测学位论文、课堂作业、SCI、EI投稿等检测；
                </el-collapse-item>
                <el-collapse-item title="Turnitin UK版" name="2">
                    针对英国大学,医院,学术机构等研发,很多的英国学校机构都是使用TurnitinUK版本，比对技术原理与Turnitin国际版完全一致，相对Turnitin国际版多收录了一个英国留学生作业、毕业论文数据库，英国地区留学生毕业论文、课堂作业以及投稿检测请选择UK版本；
                </el-collapse-item>
                <!-- <el-collapse-item title="iThenticate" name="3">
                    比对的范围包括93%的热门期刊内容以及700多亿个当前存档的网页。全球1300家顶级期刊使用iThenticate检查和评审提交的稿件。易于使用的报告使您可以轻松地缩小严重相似的范围并保护您的声誉。
                </el-collapse-item> -->
                <!-- <div style="text-align: center">
                    <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>
                    添加客服，免费获取推荐期刊
                </div> -->
            </el-collapse>
<!--            <div v-if="type==2" style="text-align: initial;">-->
<!--                （1）论文润色、翻译和降重仅限生物和医学领域，其他领域请联系客服。服务过程有任何问题请添加微信进行沟通。<br/>-->
<!--                （2）稿件凭编号或审稿人的质疑语言问题截图，可重复润色（在润好的版本上，改动字数在200字内的，可以免费润色；超过200字的需作为新稿件重新提交）。<br/>-->
<!--                （3）如需加急、格式调整等服务，请添加客服微信<br/>-->
<!--                <div style="text-align: center">-->
<!--                    <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>-->
<!--                    扫码（添加微信号cytotry）联系客服-->
<!--                </div>-->
<!--            </div>-->
<!--            <div v-if="type==3" style="text-align: initial;">-->
<!--                （1）对于降重服务，用户提交的稿件需要经我们确认，稿件中科学术语过多等因素会导致重复率很难降低到20% 以内。需要跟用户详细沟通。<br/>-->
<!--                （2）如需加急、格式调整等服务，请添加客服微信<br/>-->
<!--                <div style="text-align: center">-->
<!--                    <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>-->
<!--                    扫码（添加微信号cytotry）联系客服-->
<!--                </div>-->
<!--            </div>-->
               <!-- <div style="text-align: initial;">
               <div style="text-align: center">
                   <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>
                   扫码（添加微信号cytotry）联系客服
               </div>
           </div> -->
        </div>
    </div>

    <div class="tool mt15">
        <div>

               <div style="text-align: initial;">
               <div style="text-align: center">
                   <img src="../assets/wechat_qrcode.jpg" width="160px" height="160px" style="padding-top: 20px;"><br/>
                   扫码（添加微信号cytotry）联系客服
               </div>
           </div>
        </div>
    </div>
  </div>

</template>


<script>
export default {
    props: ["type"],
    name: "PaperCheckLeftBar",
    data() {
      return {
        polishData: [{
          numberOfWords: '1-1800',
          cycle: '5；4；3；2',
          expense: '700；1100；1300；1600',
        }, {
          numberOfWords: '1801-4000',
          cycle: '5；4；3；2',
          expense: '1000；1300；1600；1800',
        }, {
          numberOfWords: '4001-7000',
          cycle: '7；4；3；2',
          expense: '1600；1800；2100；2400',
        }, {
          numberOfWords: '7001-10000',
          cycle: '7；6；5',
          expense: '2300；2500；2800',
        }],
        ChineseEnglishTranslation:[{
          numberOfWords: '1-1800',
          cycle: '4',
          expense: '1800'
        }, {
          numberOfWords: '1801-4000',
          cycle: '6',
          expense: '2500'
        }, {
          numberOfWords: '4001-7000',
          cycle: '8',
          expense: '3500'
        }, {
          numberOfWords: '7001-10000',
          cycle: '10',
          expense: '4500'
        }],
        DropWeight:[{
          numberOfWords: '1-1800',
          RepetitionRate:'20-40；41-60；61-70',
          cycle: '3；5；7',
          expense: '1000；1900；2600'
        }, {
          numberOfWords: '1801-4000',
          RepetitionRate:'20-40；41-60；61-70',
          cycle: '3；5；7',
          expense: '1800；3000；4000'
        }, {
          numberOfWords: '4001-7000',
          RepetitionRate:'20-40；41-60；61-70',
          cycle: '5；7；10',
          expense: '2500；4000；5000'
        }, {
          numberOfWords: '7001-10000',
          RepetitionRate:'20-40；41-60；61-70',
          cycle: '5；10；14',
          expense: '3300；5000；6700'
        }],
        DuplicateChecking:[{
            category:'iThenticate',
            expense:'7.7/500词'
        },
        {
            category:'Turnitin UK版',
            expense:'1.66/500词'
        },
        {
            category:'Turnitin 国际版',
            expense:'1.66/500词'
        }],
        dialogTableVisible:false,
        determine:''
      }
    },
    methods:{
    },
    created() {
        this.determine = this.$router.currentRoute.path.split('/')[2]
    },
}
</script>

<style scoped>
.tool { width: 268px; background: #fff; border: #e8e8e8 1px solid; overflow: hidden; }
.tool h3 { line-height: 54px; border-bottom: #e8e8e8 1px solid; padding:0 20px ;font-size: 18px; font-weight: bold; color: #555;}
.tool h3 { line-height: 54px; padding:0 20px; border-bottom: #e8e8e8 1px solid; font-size: 16px; font-weight: bold; color: #555;}
.tool h3 a { float: right; font-size: 14px; font-weight: normal;}
.tool > div {
    margin: 20px;
    /* text-align: center; */
}.tool button {
    border: 1px solid #000000;
}
.mt15 { margin-top: 15px;}

.buttons {
    display: grid;
}

.buttons a {
    margin: 0 0 0 200px;
}
.buttons a:hover{
    color: #0b8f9d;
}
#mt16,
#mt17{
    margin: 0px;
    padding: 0 20px 0;
    display: flex;
    align-items: center;
    border-bottom: #e8e8e8 1px solid;
    justify-content:  space-between;
}
#mt17{
    justify-content: space-between;
    padding: 0 20px;
    border-top: #e8e8e8 1px solid;
    border-bottom: #e8e8e8 0px solid;
}
.check{
    margin-right: 0px;
}
.check:hover{
    color: #0b8f9d;
    cursor: pointer;
}
.title,
.title1{
    line-height: 54px;
    padding:0 5px;
    margin: 0px;
    font-size: 16px;
    font-weight: bold;
    color: #555;
}
</style>
<style>
.paper-check-instruction .el-collapse-item__wrap {
    text-align: justify;
}
.tool button[data-v-55260810]{
    border: 0px solid;
    color: #555;
}
.tool button[data-v-55260810]:hover{
    color: #0b8f9d;
}
.el-dialog{
    width: 700px;
}
.el-table .el-table__cell {
    padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PaperCheckLeftBar.vue